import Container from "@mui/material/Container";
import MetaHeader from "./components/MetaHeader";
import Router from "./router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getLocalStorageLocale } from "./helper/LocalStorageHelper";

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = getLocalStorageLocale();
    i18n.changeLanguage(lang);
  }, []);

  return (
    <MetaHeader>
      <Container disableGutters maxWidth={false}>
        <Router />
      </Container>
    </MetaHeader>
  );
}

export default App;
